export default class Asset extends Backbone.Model
  defaults:
    asset_id: 0
    persisted: false
    mediaLibAsset: false
    relationship: "assets"
    assetType: "standard"

  url: ->
    "/#{@assetablePath()}/#{@get("assetableId")}/#{@get("relationship")}/#{@get("asset_id")}"

  assetablePath: ->
    switch @get("assetableType")
      when "Story" then "stories"
      when "Field" then "fields"
      when "SocialPost" then "social_posts"

  save: (onSuccess) ->
    @onSuccess = onSuccess

    if @get("mediaLibAsset")
      @saveAssetting()
    else
      @processUpload()

  update: (data, callbacks) ->
    $.ajax
      type: "PUT"
      url: @url()
      dataType: "json"
      data: { asset: data }
      success: (data) =>
        @set(data.asset)
        callbacks.success() if callbacks.success
      error: ->
        callbacks.error() if callbacks.error
        contently.flash.alert("There was an error updating your file.")

  saveAssetting: ->
    $.ajax
      type: 'POST'
      url: @url() + '/assetting'
      data: { asset_type: @get("assetType") }
      success: =>
        @set(persisted: true)
        @onSuccess()
      error: @onSaveError

  onSaveError: (jqXHR, textStatus, errorThrown) =>
    @set("processing", false)
    jsonResponse = JSON.parse(jqXHR.responseText)
    if jsonResponse.errors
      contently.flash.alert(
        jsonResponse.errors[0]
      )
    else
      contently.flash.alert(
        "There was an error saving the file."
      )

  destroy: (options) ->
    $.ajax
      type: 'DELETE'
      url: @url()
      success: =>
        options.success()
      error: ->
        contently.flash.alert("There was an error deleting your asset.")

  hasThumbnail: ->
    return true if @get("mediaLibAsset")
    @get("fileType") in ["image/jpeg", "image/png", "image/pjpeg", "image/gif", "image/x-png", "image/bmp"]

  aboveFileSizeLimit: ->
    if !!@get("maxFileSize")
      parseInt(@get("filesize"), 10) > parseInt(@get("maxFileSize"), 10)
    else
      false

  processUpload: ->
    $.ajax
      url: "/media/s3_upload"
      type: 'POST'
      dataType: 'json'
      data: { data_remote_url: @get("url") }
      success: (data) =>
        @set
          asset_id: data.id
          url: data.url
          title: data.data_file_name
          thumb: data.thumb
          filesize: data.data_file_size
          createdBy: data.created_by
        @saveAssetting()
      error: @onSaveError



// WEBPACK FOOTER //
// ./app/javascript/backbone/platform/models/assets/asset.js.coffee